import React from "react";

export default function UpSellTab() {
  return <div>UpSellTab</div>;
}
